import angular from 'angular';
import _ from 'lodash';

class listKissOrdersCtrl {
  /* @ngInject */
  constructor($sessionStorage, OrdersFilterSvc, OrdersSvc, logger, ORDERS, $translate) {
    this.$sessionStorage = $sessionStorage;
    this.OrdersFilterSvc = OrdersFilterSvc;
    this.OrdersSvc = OrdersSvc;
    this.logger = logger;
    this.ORDERS = ORDERS;
    this.$translate = $translate;
  }

  $onInit() {
    this.gridParams = {};
    this.data = {};
    this.exportCsvHeaders = [];
    this.preparedSearchFilter = {};
    this.gridSize = 0;

    this.gridParams.paginationPageSizes = [20, 50, 100];
    this.gridParams.paginationPageSize = 20;

    //recuperer la liste des headers pour l'export
    this.exportCsvHeaders = _.map(this.ORDERS.columnDefs, 'displayName');
    this.exportCsvHeaders = _.map(this.exportCsvHeaders, column => {
      return this.$translate.instant(column);
    });

    if (this.$sessionStorage.listKissOrdersCriteria) {
      this.criterias = this.$sessionStorage.listKissOrdersCriteria;
    } else {
      this.criterias = {};
    }
  }

  /**
   * Lancer la recherche vers le serveur.
   */
  search() {
    this.$sessionStorage.listKissOrdersCriteria = this.criterias;

    // Une commande Full ne peut pas être au statut traitée
    if (
      this.criterias.orderStatus === this.ORDERS.status.processed.id.toUpperCase() &&
      this.criterias.orderType === this.ORDERS.type.order
    ) {
      this.data = { page: 0, content: [], totalElements: 0 };
    } else {
      var orderFilter = this.OrdersFilterSvc.createFilter(this.criterias, this.gridParams);
      this.preparedSearchFilter = orderFilter;
      this.searchPromise = this.OrdersSvc.searchOrders(orderFilter);

      this.searchPromise.then(
        data => {
          this.data = data;
          this.gridSize = data.totalElements;
        },
        error => {
          this.logger.error('error.generic', error);
        }
      );
    }
  }
}
angular.module('app.kissorder').component('listKissOrders', {
  templateUrl: require('./list-kiss-orders.html'),
  controller: listKissOrdersCtrl
});
